<template>
  <div class="bottom-bar-wrapper">
    <div class="content-width-1300">
      <div class="bottom-bar-left">
        <span class="item-span" @click.stop="_goPush('/other-pages/about-us')">关于我们</span>
        <span class="item-span" @click.stop="_goPush('/other-pages/contact-us')">联系我们</span>
        <span class="item-span" @click.stop="_goPush('/other-pages/user-agreement')">用户协议</span>
        <span class="item-span" @click.stop="_goPush('/other-pages/privacy-policy')">隐私政策</span>
        <span class="item-span" @click.stop="_goPush('/teacher-info')">教师信息公示</span>
      </div>
      <div class="bottom-bar-right">
        <span class="item-span">© {{yearRange[0]}} - {{yearRange[1]}} 看山科技版权所有</span>
        <a class="item-span" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" onfocus="this.blur();">京ICP备13047501号-5</a> 
        <a class="item-span" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033386" target="_blank" onfocus="this.blur();"><img class="beian" src="../../assets/beian.png" alt=""> 京公网安备 11010802033386号</a> 
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BottomBar',
  data() {
    return {
      yearRange: [],
    }
  },
  methods: {
    _goPush(path) {
      let routeUrl = this.$router.resolve({ path: path });
      window.open(routeUrl.href, '_blank');
    }
  },
  created() {
    let year = new Date().getFullYear();
    this.yearRange = [year - 1, year];
  }
}
</script>
<style lang="less">
@color-main: #03B2B2;
.bottom-bar-wrapper {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: @color-main;
  font-size: 12px;
  .content-width-1300 {
    padding: 0 50px;
    height: 100%;
    .item-span {
      color: #fff;
      cursor: pointer;
    }
    .bottom-bar-left {
      float: left;
      .item-span {
        margin-right: 36px;
        &:hover {
          text-shadow: 0 0 2px #fff;
        }
      }
    }
    .bottom-bar-right {
      float: right;
      .item-span {
        margin-left: 36px;
        cursor: default;
        .beian {
          display: inline-block;
          vertical-align: top;
          padding-top: 16px;
        }
      }
      a.item-span {
        cursor: pointer !important;
        &:hover {
          text-decoration: none;
          text-shadow: 0 0 2px #fff;
        }
      }
    }
  }
}
</style>